var map = {
	"./Alan Sill.jpg": 3236,
	"./Alex Uta.jpg": 126,
	"./Auluck-Nitin.jpeg": 1883,
	"./Ben McCamish.jpg": 2799,
	"./Brian Larkins.jpg": 9035,
	"./David Chiu.jpg": 7954,
	"./Ganesh Neelakanta Iyer.jpg": 4231,
	"./Hohai University.png": 6835,
	"./Jianwu Wang.jpg": 2816,
	"./Josef Spillner.jpg": 1382,
	"./Kenneth Johnson.jpg": 2283,
	"./Luiz Bittencourt.jpg": 8139,
	"./Ngan Nguyen.jpg": 3481,
	"./North Texas.png": 9277,
	"./Pamela Delgado.jpg": 6993,
	"./Paolo Falcarin.jpg": 8658,
	"./Praveen Kumar Donta.png": 8074,
	"./Song Fu.jpg": 2589,
	"./Texas Tech.png": 9928,
	"./Tommy Dang.jpg": 4054,
	"./U of Campinas.png": 5265,
	"./U of Puget Sound.png": 5568,
	"./UMBC.png": 2438,
	"./WSU.png": 8954,
	"./Xinghui Zhao.jpg": 2848,
	"./Yan Tang.jpg": 7347,
	"./Zichuan Xu.jpg": 6157,
	"./ahmed-200x301.png": 5972,
	"./unknown.jpg": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8479;